/** Resume delivery for pending website suggestions, including after reload. */
export function hasPendingKeywordSuggestions(messages:readonly {createdAt:string;views?:unknown}[],now=Date.now()):boolean {
 return messages.some(message=>{
  const age=now-new Date(message.createdAt).getTime();
  return age>=0&&age<660000&&(Array.isArray(message.views)?message.views:[]).some((view:any)=>
   view?.template==='website-report'&&view.creation?.keywordSelectionPending===true&&view.creation.keywordSuggestions?.state==='pending');
 });
}
